module.exports = __webpack_public_path__ + "img/tr.2fa4d38c.svg";